//import the Polymer library
import { html, PolymerElement } from "@polymer/polymer/polymer-element.js";
import General from "../../../../utils/General";


import "./VideoPlayer.style";

class VideoPlayer extends PolymerElement {
  static get template() {
    return html`
      <link href="https://vjs.zencdn.net/7.20.1/video-js.css" rel="stylesheet" />
      <style include="video-player-style"></style>
      <div class="container-video">
        <video
            id="ecourse_video_player"
            class="video-js vjs-default-skin vjs-big-play-centered"
            controls
            preload="auto"
            poster="{{urlBanner}}"
            data-setup=''
        >
            <source src="{{urlVideo}}" type="{{type}}">
        </video>
      </div>
    `;
  }

  static get properties() {
    return {
      urlVideo: {
        type: String,
        value: null,
      },
      urlBanner: {
        type: String,
        value: null,
      },
      type: {
        type: String,
        value: null,
      },
      recording10: {
        type: Boolean,
        value: false,
      },
      recording25: {
        type: Boolean,
        value: false,
      },
      recording50: {
        type: Boolean,
        value: false,
      },
      recording75: {
        type: Boolean,
        value: false,
      },
      recording90: {
        type: Boolean,
        value: false,
      },
    }
  }

  ready() {
    super.ready();
    if (this.urlVideo) this.type = General.formatVideo(this.urlVideo);
    this.initPlayer();
  }

  initPlayer() {
    let intervalId;
    const player = videojs(this.shadowRoot.querySelector("#ecourse_video_player"), { liveui: true });
    player.on("play", () => {
      intervalId = setInterval(() => {
        const currentTime = player.currentTime();
        const totalDuration = player.duration();
        const percentage = (currentTime / totalDuration) * 100;
        if(percentage >= 10 && !this.recording10) {
          this.dispatchEvent(new CustomEvent("tracking-progress-recording", { detail: 10 }));
          this.recording10 = true;
        } else if(percentage >= 25 && !this.recording25) {
          this.dispatchEvent(new CustomEvent("tracking-progress-recording", { detail: 25 }));
          this.recording25 = true;
        } else if(percentage >= 50 && !this.recording50) {
          this.dispatchEvent(new CustomEvent("tracking-progress-recording", { detail: 50 }));
          this.recording50 = true;
        } else if(percentage >= 75 && !this.recording75) {
          this.dispatchEvent(new CustomEvent("tracking-progress-recording", { detail: 75 }));
          this.recording75 = true;
        } else if(percentage >= 90 && !this.recording90) {
          this.dispatchEvent(new CustomEvent("tracking-progress-recording", { detail: 90 }));
          this.recording90 = true;
        }
      }, 1000);
      this.dispatchEvent(new CustomEvent("player", { detail: "play" }));
    });
    player.on("pause", () => {
      clearInterval(intervalId);
      this.dispatchEvent(new CustomEvent("player", { detail: "pause" }));
    });

    player.on("ended", () => {
      clearInterval(intervalId);
      this.dispatchEvent(new CustomEvent("player", { detail: "ended" }));
    });

    player.on("error", () => this.dispatchEvent(new CustomEvent("player", { detail: "error" })));
  }
}
customElements.define("video-player", VideoPlayer);